import axios from "axios";

const API_URL = process.env.REACT_APP_API_PROD || "https://api.easyph.com.co/api";

// Asuntos
export interface SOSAsunto {
    sas_codigo: number;
    sas_nombre: string;
    sas_fecha_creacion: string;
    sas_unidad_residencial: string;
    sas_unidad_residencial_nombre: string;
    sas_prioridad: number;
    sas_activo: number;
    sas_activo_nombre: string;
}

export const getSOSAsuntos = async (unidad_residencial: string): Promise<SOSAsunto[]> => {
    try {
        const response = await axios.post(`${API_URL}/SOS_asunto/Obtener_todos`, {
            codigo: "",
            unidad_residencial,
            activo: ""
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data.object_ || [];
    } catch (error) {
        console.error("Error fetching SOS asuntos:", error);
        throw error;
    }
};

export const insertSOSAsunto = async (nombre: string, unidad_residencial_codigo: string, prioridad: number) => {
    try {
        const response = await axios.post(`${API_URL}/SOS_asunto/Insertar`, {
            nombre,
            unidad_residencial_codigo,
            prioridad
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error inserting SOS asunto:", error);
        throw error;
    }
};

export const updateSOSAsunto = async (codigo: number, nombre: string, prioridad: number, activo: number) => {
    try {
        const response = await axios.post(`${API_URL}/SOS_asunto/Modificar`, {
            codigo,
            nombre,
            prioridad,
            activo
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating SOS asunto:", error);
        throw error;
    }
};

// Teléfonos
export interface SOSTelefono {
    ste_codigo: number;
    ste_entidad: string;
    ste_imagen_nombre: string;
    ste_unidad_residencial: string;
    ste_unidad_residencial_nombre: string;
    ste_telefono: string;
    ste_prioridad: number;
    ste_activado: number;
    ste_activado_nombre: string;
}

export const getSOSTelefonos = async (unidad_residencial: string): Promise<SOSTelefono[]> => {
    try {
        const response = await axios.post(`${API_URL}/SOS_telefono/Obtener_todos`, {
            codigo: "",
            unidad_residencial,
            activo: ""
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data.object_ || [];
    } catch (error) {
        console.error("Error fetching SOS telefonos:", error);
        throw error;
    }
};

export const insertSOSTelefono = async (entidad: string, unidad_residencial_codigo: string, telefono: string, prioridad: number) => {
    try {
        const response = await axios.post(`${API_URL}/SOS_telefono/Insertar`, {
            entidad,
            unidad_residencial_codigo,
            telefono,
            prioridad
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error inserting SOS telefono:", error);
        throw error;
    }
};

export const updateSOSTelefono = async (codigo: number, entidad: string, telefono: string, prioridad: number, activo: number) => {
    try {
        const response = await axios.post(`${API_URL}/SOS_telefono/Modificar`, {
            codigo,
            entidad,
            telefono,
            prioridad,
            activo
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating SOS telefono:", error);
        throw error;
    }
};

// Reportados
export interface SOSReportado {
    sre_codigo: number;
    sre_sos_asunto: number;
    sre_sos_asunto_nombre: string;
    sre_fecha: string;
    sre_unidad_residencial: string;
    sre_torre: string;
    sre_torre_nombre: string;
    sre_apartamento: string;
    sre_apartamento_nombre: string;
    sre_usuario_residente_nombre: string;
    sre_fecha_revision: string;
    sre_apartamento_usuario_revision: string;
    sre_tipo_usuario_revision: string;
    sre_usuario_revision: string;
    sre_usuario_revision_nombre: string;
}

export const getSOSReportadosPendientes = async (unidad_residencial_codigo: string): Promise<SOSReportado[]> => {
    try {
        const response = await axios.post(`${API_URL}/SOS_reportado/Pendiente_Revision_Obtener_todos`, {
            codigo: "",
            unidad_residencial_codigo
        }, {
            headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json'
            }
        });

        const data = response.data;
        const lista = data?.object_ || [];
        const code = data?.code;

        if (code !== "1") {
            return [];
        }

        if (!Array.isArray(lista) || lista.length === 0) {
            return [];
        }

        const first: any = lista[0];
        if (first && (first.asa_codigo === "0" || first.asa_codigo === 0)) {
            return [];
        }

        return lista as SOSReportado[];
    } catch (error) {
        console.error("Error fetching SOS reportados pendientes:", error);
        throw error;
    }
};
